import script from "./DailyGoalWheel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DailyGoalWheel.vue?vue&type=script&setup=true&lang=ts"

import "./DailyGoalWheel.vue?vue&type=style&index=0&id=edc7ae7a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edc7ae7a"]])

export default __exports__